module.exports = __webpack_public_path__ + "media/images/success-512a678700dfd55aec3d1cb8a0abae25.svg";